import { hmac } from "@noble/hashes/hmac.js";
import { hkdf } from "@noble/hashes/hkdf.js";
import { sha256 } from "@noble/hashes/sha2.js";
import { assertKeyLength, utf8ToBytes } from "./bytes.js";
export const PERSONAL_SCOPE = "personal";
const TITLE_INFO = utf8ToBytes("passwordflow/title-v1");
const EMPTY_SALT = new Uint8Array(0);
/** Binds an item ciphertext to its scope (personal or org) and item id, so the server cannot move ciphertexts between items. */
export function itemAad(scope, itemId) {
    return utf8ToBytes(`passwordflow/item-v2|${scope}|${itemId}`);
}
function toHex(bytes) {
    return Array.from(bytes, (b) => b.toString(16).padStart(2, "0")).join("");
}
/** Keyed title digest for the server-side index. Without the key the server cannot test guessed titles. */
export function keyedTitleHash(key, title) {
    assertKeyLength(key, 32, "TitleKey");
    const macKey = hkdf(sha256, key, EMPTY_SALT, TITLE_INFO, 32);
    const normalized = title.trim().toLowerCase();
    return toHex(hmac(sha256, macKey, utf8ToBytes(normalized)));
}
//# sourceMappingURL=items.js.map